import { Component } from 'react'
import { connect } from 'react-redux'

import './index.scss'

class NotFound extends Component {
  render () {
    let { lang } = this.props
    return (
      <div className='app-page page-not-found'>
        <div className='not-found-container'>
          <div className='code'>404</div>
          <div className='tip'>{lang === 'cn' ? '很抱歉，您访问的页面不存在' : 'SORRY,PAGE NOT FOUND'}</div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(NotFound)